import React, { Component } from "react";
import { siteConfig } from "../../settings/config";
import { FormattedMessage, injectIntl } from "react-intl";
import { Row, Col, Space } from "antd";
import { CheckOutlined, CloseOutlined } from "@ant-design/icons";

class PasswordCriteria extends Component {
  constructor(props) {
    super(props);

    this.state = {
      hasUppercase: false,
      hasLowercase: false,
      isLongEnough: false,
      hasSpecialChar: false,
      hasNumber: false,
      confirmPassword: false,
    };
  }

  componentWillReceiveProps(nextProps) {
    this.getPasswordCompliance(nextProps.password, nextProps.confirm_password);
  }

  getPasswordCompliance(password, confirm_password) {
    let stateObj = {};

    // Does the password include 1 uppercase
    if (/.*[A-Z]{1,}.*/.test(password)) {
      stateObj["hasUppercase"] = true;
    } else {
      stateObj["hasUppercase"] = false;
    }

    // Does the password include 1 lowercase
    if (/.*[a-z]{1,}.*/.test(password)) {
      stateObj["hasLowercase"] = true;
    } else {
      stateObj["hasLowercase"] = false;
    }

    // Does the password include special characters, whitespace or numbers
    if (/.*[-!$%^&*()_+|~=`{}[\]:";'<>?,./@#]{1,}.*/.test(password)) {
      stateObj["hasSpecialChar"] = true;
    } else {
      stateObj["hasSpecialChar"] = false;
    }

    // Does the password include numbers
    if (/.*[0-9]{1,}.*/.test(password)) {
      stateObj["hasNumber"] = true;
    } else {
      stateObj["hasNumber"] = false;
    }

    // Is the password at least 8 characters
    if (password.length >= 8) {
      stateObj["isLongEnough"] = true;
    } else {
      stateObj["isLongEnough"] = false;
    }

    if (this.props.show_confirm && confirm_password === password) {
      stateObj["confirmPassword"] = true;
    } else if (this.props.show_confirm && confirm_password !== password) {
      stateObj["confirmPassword"] = false;
    }

    stateObj["validPassword"] =
      stateObj.hasLowercase &&
      stateObj.hasUppercase &&
      stateObj.hasSpecialChar &&
      stateObj.isLongEnough &&
      stateObj.hasNumber;

    if (this.props.show_confirm) {
      stateObj["validPassword"] = stateObj["validPassword"] && stateObj["confirmPassword"];
    }
    this.setState(stateObj);
  }

  render() {
    return (
      <Row className={typeof this.props.className !== "undefined" ? this.props.className : ""}>
        <Col xs={{ span: 24 }} md={{ span: 11 }}>
          <Space>
            {this.state.hasLowercase ? (
              <CheckOutlined className="textColorSuccess" />
            ) : (
              <CloseOutlined className="text-color-error" />
            )}
            <div className="text-capitalize-first">
              <FormattedMessage id="a lowercase character" />
            </div>
          </Space>
        </Col>
        <Col xs={{ span: 24 }} md={{ span: 11, offset: 1 }}>
          <Space>
            {this.state.hasUppercase ? (
              <CheckOutlined className="textColorSuccess" />
            ) : (
              <CloseOutlined className="text-color-error" />
            )}
            <div className="text-capitalize-first">
              <FormattedMessage id="an uppercase character" />
            </div>
          </Space>
        </Col>
        <Col xs={{ span: 24 }} md={{ span: 11 }}>
          <Space>
            {this.state.hasSpecialChar ? (
              <CheckOutlined className="textColorSuccess" />
            ) : (
              <CloseOutlined className="text-color-error" />
            )}
            <div className="text-capitalize-first">
              <FormattedMessage id="a symbol" />
            </div>
          </Space>
        </Col>
        <Col xs={{ span: 24 }} md={{ span: 11, offset: 1 }}>
          <Space>
            {this.state.hasNumber ? (
              <CheckOutlined className="textColorSuccess" />
            ) : (
              <CloseOutlined className="text-color-error" />
            )}
            <div className="text-capitalize-first">
              <FormattedMessage id="a number" />
            </div>
          </Space>
        </Col>
        <Col xs={{ span: 24 }} md={{ span: 11 }}>
          <Space>
            {this.state.isLongEnough ? (
              <CheckOutlined className="textColorSuccess" />
            ) : (
              <CloseOutlined className="text-color-error" />
            )}
            <div className="text-capitalize-first">
              {this.props.intl.formatMessage(
                {
                  id: "at least {length} characters",
                  defaultMessage: "at least {length} characters",
                  description: "at least {length} characters",
                },
                { length: siteConfig.passwordLength }
              )}
            </div>
          </Space>
        </Col>
        {this.props.show_confirm ? (
          <Col xs={{ span: 24 }} md={{ span: 12, offset: 1 }}>
            <Space>
              {this.props.password === this.props.confirm_password &&
              this.props.password?.length > 0 &&
              this.props.confirm_password?.length > 0 ? (
                <CheckOutlined className="textColorSuccess" />
              ) : (
                <CloseOutlined className="text-color-error" />
              )}
              <div className="text-capitalize-first">{this.props.intl.formatMessage({ id: "passwords match" })}</div>
            </Space>
          </Col>
        ) : (
          false
        )}
      </Row>
    );
  }
}

PasswordCriteria.defaultProps = {
  show_confirm: false,
};

export default injectIntl(PasswordCriteria);

export function validatePassword(password, show_confirm = false, confirm_password) {
  // Does the password include 1 uppercase

  let x =
    /.*[A-Z]{1,}.*/.test(password) &&
    // Does the password include 1 lowercase
    /.*[a-z]{1,}.*/.test(password) &&
    // Does the password include special characters
    /.*[-!$%^&*()_+|~=`{}[\]:";'<>?,./@#]{1,}.*/.test(password) &&
    // Does the password include numbers
    /.*[0-9]{1,}.*/.test(password) &&
    // Is the password long enough
    password.length >= siteConfig.passwordLength;
  if (show_confirm) {
    x = x && password === confirm_password;
  }
  return x;
}
